export default "__VITE_ASSET__dA$GnyX9__"